import React, {useCallback, useState} from 'react';
import View from './view';
import {Props} from './model';
import {AcceptorBranch} from '../../../../../shared/models/api/productDetailedResponsePayload';

export const ProductGeoMap = (props: Props) => {
  const [activeAcceptorBranch, setActiveAcceptorBranch] = useState<AcceptorBranch | null>(null);
  const onClickAcceptorBranch = useCallback(
    (val: AcceptorBranch | null) => {
      setActiveAcceptorBranch(val);
    },
    [setActiveAcceptorBranch],
  );
  const viewProps = {
    ...props,
    activeAcceptorBranch,
    onClickAcceptorBranch,
  };
  return <View {...viewProps} />;
};
